import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import CustomerMasterLayout from '../../../../layouts/customer/CustomerMasterLayout';
import '../../../../assets/styles/customer/CustomerSettings.css';
import MyLayout from '../../../../layouts/customer/MyLayout';

const CUSTOMER_ID = 1; // TODO: auth se aayega
const BASE_URL    = 'http://localhost:8000';

/* ══════════════════════════════════
   PROFILE TAB — Field component (bahar)
══════════════════════════════════ */
const Field = ({ label, fKey, icon, type = 'text', isSelect, options, form, set }) => (
  <div className="csett-form-group">
    <label className="csett-form-label">{label}</label>
    <div className="csett-input-wrap">
      <i className={`bi ${icon} csett-input-icon`} />
      {isSelect ? (
        <select className="csett-input csett-input--select" value={form[fKey]} onChange={e => set(fKey, e.target.value)}>
          {options.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
      ) : (
        <input className="csett-input" type={type} value={form[fKey]} onChange={e => set(fKey, e.target.value)} />
      )}
    </div>
  </div>
);

/* ══════════════════════════════════
   SECURITY TAB — PwField component (bahar)
══════════════════════════════════ */
const PwField = ({ label, fKey, placeholder, form, show, set, toggle }) => (
  <div className="csett-form-group">
    <label className="csett-form-label">{label}</label>
    <div className="csett-input-wrap">
      <i className="bi bi-lock csett-input-icon" />
      <input
        className="csett-input csett-input--pw"
        type={show[fKey] ? 'text' : 'password'}
        placeholder={placeholder}
        value={form[fKey]}
        onChange={e => set(fKey, e.target.value)}
      />
      <button className="csett-pw-eye" type="button" onClick={() => toggle(fKey)}>
        {show[fKey] ? <EyeOff size={14} /> : <Eye size={14} />}
      </button>
    </div>
  </div>
);

/* ══════════════════════════════════
   PROFILE TAB
══════════════════════════════════ */
const ProfileTab = () => {

  // 1. STATES
  const [form, setForm] = useState({
    fullName:    'Rahul Ahmed',
    phonenumber: '03001234567',
    mwcity_id:   '1',
    mwarea_id:   '1',
  });
  const [loading,    setLoading]    = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg,   setErrorMsg]   = useState('');

  const CITIES = [{ id: '1', name: 'Lahore' }, { id: '2', name: 'Karachi' }, { id: '3', name: 'Islamabad' },
                  { id: '4', name: 'Faisalabad' }, { id: '5', name: 'Gujranwala' }];
  const AREAS  = [{ id: '1', name: 'DHA' }, { id: '2', name: 'Gulberg' }, { id: '3', name: 'Model Town' },
                  { id: '4', name: 'Johar Town' }, { id: '5', name: 'Bahria Town' }];

  // 2. onChange
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // 3. Button click → function
  const handleSave = async () => {
    setSuccessMsg(''); setErrorMsg('');
    if (!form.fullName || !form.phonenumber) { setErrorMsg('Name aur Phone zaroori hain.'); return; }
    setLoading(true);
    console.log('🚀 Profile update ho rahi hai...', form);

    // 4. FormData
    const formData = new FormData();
    formData.append('customer_id', CUSTOMER_ID);
    formData.append('fullName',    form.fullName);
    formData.append('phonenumber', form.phonenumber);
    formData.append('mwcity_id',   form.mwcity_id);
    formData.append('mwarea_id',   form.mwarea_id);

    // 5. API Call
    try {
      const response = await fetch(`${BASE_URL}/api/customer/settings/updateProfile`, {
        method: 'POST', body: formData,
      });
      const data = await response.json();
      console.log('✅ Profile response:', data);
      data.success ? setSuccessMsg('Profile update ho gai! ✅') : setErrorMsg(data.message);
    } catch (error) {
      console.error('❌ Error:', error);
      setErrorMsg('Server is not connected');
    } finally { setLoading(false); }
  };

  return (
    <div className="csett-panel">
      <h3 className="csett-panel__heading">Profile Information</h3>
      <Field label="Full Name"    fKey="fullName"    icon="bi-person"    form={form} set={set} />
      <Field label="Phone Number" fKey="phonenumber" icon="bi-telephone" form={form} set={set} />
      <Field label="City"         fKey="mwcity_id"   icon="bi-geo-alt"   form={form} set={set} isSelect options={CITIES} />
      <Field label="Area"         fKey="mwarea_id"   icon="bi-geo-alt"   form={form} set={set} isSelect options={AREAS}  />
      {successMsg && <p className="csett-success">{successMsg}</p>}
      {errorMsg   && <p className="csett-error">{errorMsg}</p>}
      <button className="csett-save-btn" onClick={handleSave} disabled={loading}>
        <i className="bi bi-floppy me-2" />{loading ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  );
};

/* ══════════════════════════════════
   SECURITY TAB
══════════════════════════════════ */
const SecurityTab = () => {

  // 1. STATES
  const [form, setForm]         = useState({ current: '', newPass: '', confirm: '' });
  const [show, setShow]         = useState({ current: false, newPass: false, confirm: false });
  const [loading,    setLoading]    = useState(false);
  const [errorMsg,   setErrorMsg]   = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  // 2. onChange
  const set    = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const toggle = k      => setShow(s => ({ ...s, [k]: !s[k] }));

  // 3. Button click → function
  const handleUpdate = async () => {
    setErrorMsg(''); setSuccessMsg('');
    if (!form.current || !form.newPass || !form.confirm) { setErrorMsg('Sab fields zaroori hain.'); return; }
    if (form.newPass.length < 8)       { setErrorMsg('Password 8 characters se kam nahi hona chahiye.'); return; }
    if (form.newPass !== form.confirm) { setErrorMsg('Naye passwords match nahi kar rahe.'); return; }
    setLoading(true);
    console.log('Password Updated');

    // 4. FormData
    const formData = new FormData();
    formData.append('customer_id',      CUSTOMER_ID);
    formData.append('current_password', form.current);
    formData.append('new_password',     form.newPass);

    // 5. API Call
    try {
      const response = await fetch(`${BASE_URL}/api/customer/settings/changePassword`, {
        method: 'POST', body: formData,
      });
      const data = await response.json();
      console.log('✅ Password response:', data);
      if (data.success) { setSuccessMsg('Password update ho gaya! ✅'); setForm({ current: '', newPass: '', confirm: '' }); }
      else { setErrorMsg(data.message); }
    } catch (error) {
      console.error('❌ Error:', error);
      setErrorMsg('Server is not connected');
    } finally { setLoading(false); }
  };

  return (
    <div className="csett-panel">
      <h3 className="csett-panel__heading">Change Password</h3>
      <PwField label="Current Password"     fKey="current" placeholder="Enter current password"
        form={form} show={show} set={set} toggle={toggle} />
      <PwField label="New Password"         fKey="newPass" placeholder="Enter new password"
        form={form} show={show} set={set} toggle={toggle} />
      <PwField label="Confirm New Password" fKey="confirm" placeholder="Confirm new password"
        form={form} show={show} set={set} toggle={toggle} />
      {errorMsg   && <p className="csett-error">{errorMsg}</p>}
      {successMsg && <p className="csett-success">{successMsg}</p>}
      <button className="csett-save-btn" onClick={handleUpdate} disabled={loading}>
        <i className="bi bi-shield-lock me-2" />{loading ? 'Updating...' : 'Update Password'}
      </button>
    </div>
  );
};

/* ══════════════════════════════════
   NOTIFICATIONS TAB — Toggle component (bahar)
══════════════════════════════════ */
const Toggle = ({ label, desc, prefKey, prefs, toggle }) => (
  <div className="csett-toggle-row">
    <div>
      <div className="csett-toggle-label">{label}</div>
      <div className="csett-toggle-desc">{desc}</div>
    </div>
    <button className={`csett-toggle${prefs[prefKey] ? ' csett-toggle--on' : ''}`} onClick={() => toggle(prefKey)}>
      <span className="csett-toggle__knob" />
    </button>
  </div>
);

/* ══════════════════════════════════
   NOTIFICATIONS TAB
══════════════════════════════════ */
const NotificationsTab = () => {

  // 1. STATES
  const [prefs, setPrefs]           = useState({ appNotification: true, emailNotification: false });
  const [loading,    setLoading]    = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg,   setErrorMsg]   = useState('');

  // 2. onChange
  const toggle = (k) => setPrefs(p => ({ ...p, [k]: !p[k] }));

  // 3. Button click → function
  const handleSave = async () => {
    setSuccessMsg(''); setErrorMsg('');
    setLoading(true);
    console.log('Notification updated', prefs);

    // 4. FormData
    const formData = new FormData();
    formData.append('customer_id',       CUSTOMER_ID);
    formData.append('appNotification',   prefs.appNotification   ? 1 : 0);
    formData.append('emailNotification', prefs.emailNotification ? 1 : 0);

    // 5. API Call
    try {
      const response = await fetch(`${BASE_URL}/api/customer/settings/updateNotifications`, {
        method: 'POST', body: formData,
      });
      const data = await response.json();
      console.log('✅ Notifications response:', data);
      data.success ? setSuccessMsg('Preferences save ho gayi! ✅') : setErrorMsg(data.message);
    } catch (error) {
      console.error('❌ Error:', error);
      setErrorMsg('Server se connect nahi ho saka.');
    } finally { setLoading(false); }
  };

  return (
    <div className="csett-panel">
      <h3 className="csett-panel__heading">Notification Preferences</h3>
      <Toggle label="In-App Notifications" desc="Receive notifications within the app" prefKey="appNotification"   prefs={prefs} toggle={toggle} />
      <Toggle label="Email Notifications"  desc="Receive notifications via email"       prefKey="emailNotification" prefs={prefs} toggle={toggle} />
      {successMsg && <p className="csett-success mt-2">{successMsg}</p>}
      {errorMsg   && <p className="csett-error mt-2">{errorMsg}</p>}
      <button className="csett-save-btn" onClick={handleSave} disabled={loading}>
        <i className="bi bi-bell me-2" />{loading ? 'Saving...' : 'Save Preferences'}
      </button>
    </div>
  );
};

/* ══════════════════════════════════
   MAIN
══════════════════════════════════ */
const CustomerSettings = () => {
  const [tab, setTab] = useState('profile');

  const TABS = [
    { key: 'profile',       label: 'Profile',       icon: 'bi-person'      },
    { key: 'security',      label: 'Security',      icon: 'bi-shield-lock' },
    { key: 'notifications', label: 'Notifications', icon: 'bi-bell'        },
  ];

  return (
    <MyLayout>
      <CustomerMasterLayout>
        <div className="csett-wrapper">
          <div className="csett-header">
            <h1 className="csett-title">Settings</h1>
            <p className="csett-subtitle">Manage your account settings</p>
          </div>
          <div className="csett-tabs">
            {TABS.map(t => (
              <button key={t.key} className={`csett-tab${tab === t.key ? ' csett-tab--active' : ''}`} onClick={() => setTab(t.key)}>
                <i className={`bi ${t.icon} me-1`} />{t.label}
              </button>
            ))}
          </div>
          {tab === 'profile'       && <ProfileTab       />}
          {tab === 'security'      && <SecurityTab      />}
          {tab === 'notifications' && <NotificationsTab />}
        </div>
      </CustomerMasterLayout>
    </MyLayout>
  );
};

export default CustomerSettings;